export const CREATIVE_ACL_OBJECTS = [
    'Creative',
    'CreativeDetail',
    'NewCreativeComponent',
    // approval_statues are also here but we don't have routing for this one
];
